import { render, staticRenderFns } from "./wijzigingsverzoek-bevestiging.vue?vue&type=template&id=6e1fc300&"
import script from "./wijzigingsverzoek-bevestiging.vue?vue&type=script&lang=js&"
export * from "./wijzigingsverzoek-bevestiging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports